import { Delete, Edit } from "@mui/icons-material";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import TableSkeleton from "components/skeletons/TableSkeleton";
import TablePagination from "components/tablePagination";
import { deleteExpense } from "features/expense/api/expense";
import useApi from "hooks/useApi";
import moment from "moment";
import { toast } from "react-toastify";

const ExpenseTable = ({
  loading,
  allExpense,
  setAllExpense,
  setCurrExpense,
  setAddExpense,
  pagination,
  setPagination,
  setReload,
}) => {
  const rows = allExpense;
  const columns = [
    { id: "expense_number", label: "Expense No." },
    { id: "expense_category_name", label: "Category" },
    { id: "payment_method_name", label: "Payment Method" },
    { id: "name", label: "Expense Name" },
    { id: "reference_name", label: "Reference" },
    { id: "created_at", label: "Created At" },
    { id: "total", label: "Total", align: "right" },
    { id: "action", label: "Actions", minWidth: 70, align: "center" },
  ];
  const { fetchData } = useApi();

  const handleDelete = async (id) => {
    try {
      const result = await fetchData(deleteExpense(id));
      if (result.success) {
        setAllExpense(allExpense.filter((admission) => admission.id !== id));
      } else {
        toast.error(result.message);
      }
    } catch {}
  };

  const handleEditBtn = (value) => {
    setCurrExpense(value);
    setAddExpense(true);
  };

  return (
    <>
      {!loading ? (
        <TableContainer
          sx={{ height: "calc(100vh - 245px)", overflowX: "auto" }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows?.map((row) => {
                return (
                  <TableRow hover role="checkbox" key={row.id}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === "number" ? (
                            column.format(value)
                          ) : column.id === "expense_date" ? (
                            moment(value).format("ll")
                          ) : column.id === "created_at" ? (
                            moment(value).format("ll")
                          ) : column.id === "tax" ? (
                            <Typography color="#2fb42f" variant="body2">
                              {"+ " + row.symbol + value}
                            </Typography>
                          ) : column.id === "discount" ? (
                            <Typography color="#ff3535" variant="body2">
                              {"- " + row.symbol + value}
                            </Typography>
                          ) : column.id === "total" ? (
                            <Typography color="#7171ff" variant="body2">
                              {row.symbol}
                              {value + row.tax - row.discount}
                            </Typography>
                          ) : column.id === "subtotal" ? (
                            <Typography variant="body2">
                              {row.symbol + value}
                            </Typography>
                          ) : column.id === "action" ? (
                            <Box
                              sx={{
                                display: "flex",
                                gap: "10px",
                                justifyContent: "center",
                              }}
                            >
                              <IconButton onClick={() => handleEditBtn(row)}>
                                <Edit />
                              </IconButton>
                              <IconButton onClick={() => handleDelete(row.id)}>
                                <Delete />
                              </IconButton>
                            </Box>
                          ) : (
                            value
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <TableSkeleton columns={columns} tableHeight="calc(100vh - 265px)" />
      )}
      <TablePagination
        span={columns?.length}
        setReload={setReload}
        pagination={pagination}
        setPagination={setPagination}
      />
    </>
  );
};

export default ExpenseTable;
